import { useState } from 'react';
import './css/Form.css';
import validationMessageHandler from '~/helpers/validationMessageHandler.js';
import ErrorLinks from './ErrorLinks.js';

function Form({children, className, submit, formRef, hideError, dark, callbackAdditionalValidator, ...props}) {

    const [isValidated, setIsValidated] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    const validate = () => {

        handleValidate();
        if (formRef && formRef.current !== null) {
            return formRef.current.checkValidity();
        }
        return false;
    };

    const submitHandler = event => {
        event.preventDefault();

        if (validate()) {
            // Do something...
            submit();
        }

        setIsValidated(true);
    };

    const invalidHandler = e => {
        e.preventDefault();
    };

    function handleValidate() {

        const formErrors = {};

        if (!formRef || !formRef.current) return;
        for (let element of formRef.current.elements) {
            if (!element.reportValidity()) {
                let {id} = element;
                if (!id) {
                    let tempEl = element;
                    for (let i = 0; i < 8; i++) {
                        tempEl = tempEl.parentNode;
                        id = tempEl.id;
                        if (tempEl.id) break;
                    }
                }
                formErrors[id] = validationMessageHandler(element);
            }
        }

        if (callbackAdditionalValidator){
            const errors = callbackAdditionalValidator();
            Object.assign(formErrors, errors);
        }

        if (Object.keys(formErrors).length > 0){
            window.scrollTo(0, 0);
        }
        setFormErrors(formErrors);
    }

    // We want to be able to inject the "was-validated" class onto our form after a submit was attempted.
    let classNames = [];
    if (className) {
        classNames = className.split(' ');
    }

    if (isValidated) {
        classNames.push('was-validated');
    }

    return <form
        ref={formRef}
        onSubmit={submitHandler}
        {...props}
        className={classNames.join(' ') || null}
        onInvalid={invalidHandler}
        noValidate
    >
        <ErrorLinks hideError={hideError} formErrors={formErrors} dark={dark}/>
        {children}
    </form>;
}

export default Form;